// removed by extract-text-webpack-plugin
module.exports = {"wrap":"style__wrap-3lanM","siderTitle":"style__siderTitle-1Jwsx","siderTitleMini":"style__siderTitleMini-34t7c","nenuItem":"style__nenuItem-1uTsn"};


//////////////////
// WEBPACK FOOTER
// ./src/views/MainLayout/SiderBar/style.less
// module id = 643
// module chunks = 17